import React from 'react';
export const Tabs = ({ tabs, activeTab, onTabChange, actions }) => {
    const activeTabContent = tabs.find(tab => tab.id === activeTab)?.content;
    return (React.createElement("div", { className: "flex flex-col h-full" },
        React.createElement("div", { className: "flex border-b border-gray-200 bg-[#fff9ec]" },
            tabs.map((tab) => {
                const Icon = tab.icon;
                const isActive = activeTab === tab.id;
                return (React.createElement("button", { key: tab.id, onClick: () => onTabChange(tab.id), "data-tour-id": tab.id === 'publish' ? 'builder-publish-tab' : undefined, className: `group flex flex-col items-start justify-center h-20 py-2 px-4 border-b-2 transition-all duration-300 ${isActive
                        ? 'text-orange-500 border-orange-500 font-medium bg-white'
                        : 'text-gray-600 border-transparent hover:text-gray-900 hover:bg-white/50'}` },
                    React.createElement("div", { className: "flex items-center" },
                        React.createElement(Icon, { className: "w-4 h-4 mr-2" }),
                        tab.label),
                    tab.description && (React.createElement("div", { className: `text-xs text-left text-gray-500 font-normal mt-0.5 overflow-hidden transition-all duration-300 ease-out
                    ${isActive
                            ? 'opacity-100 translate-y-0'
                            : 'max-h-0 opacity-0 -translate-y-2 group-hover:max-h-10 group-hover:opacity-100 group-hover:translate-y-0'}` }, tab.description))));
            }),
            React.createElement("div", { className: "flex-grow" }),
            actions),
        React.createElement("div", { className: "flex-1 overflow-y-auto p-4  " }, activeTabContent)));
};
